module.exports = __webpack_public_path__ + "img/gb13871-92_42x55x8.prt.192dff2d.jpg";